module.exports = __webpack_public_path__ + "static/img/350.4db05a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/350.jpg
// module id = 49uZ
// module chunks = 0